/* RESPONSIBLE TEAM: team-app-security */
import ApplicationAdapter from 'embercom/adapters/application';

export default ApplicationAdapter.extend({
  urlForDeleteRecord(id, modelName, snapshot) {
    return this.urlForCreateRecord(modelName, snapshot);
  },
});
